import { useEffect } from 'react'
import { logger } from '../services/logger'

export const useErrorHandler = () => {
  useEffect(() => {
    // Обработчик необработанных ошибок JavaScript
    const handleUnhandledError = (event: ErrorEvent) => {
      logger.logError(event.error || event.message, {
        errorType: 'unhandled_error',
        additionalData: {
          filename: event.filename,
          lineno: event.lineno,
          colno: event.colno,
        }
      })
    }

    // Обработчик необработанных отклонений Promise
    const handleUnhandledRejection = (event: PromiseRejectionEvent) => {
      logger.logError(event.reason, {
        errorType: 'unhandled_promise_rejection',
        additionalData: {
          type: typeof event.reason,
        }
      })
    }

    // Добавляем обработчики
    window.addEventListener('error', handleUnhandledError)
    window.addEventListener('unhandledrejection', handleUnhandledRejection)

    // Очистка при размонтировании
    return () => {
      window.removeEventListener('error', handleUnhandledError)
      window.removeEventListener('unhandledrejection', handleUnhandledRejection)
    }
  }, [])
}
